import {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import axios from "axios";
import './MainComponent.css';
import MultipleExerciseComponent from "./MultipleExerciseComponent";

const my_styles = {margin: '0.1em', border: '1px solid lightgray', fontSize: '10pt', whiteSpace: 'pre-wrap'};

export default function MainComponent() {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    let [searchParams, setSearchParams] = useSearchParams();
    const [jsonData, setJsonData] = useState(null);
    const [exerciseList, setExerciseList] = useState(null);
    const [lesetext, setLesetext] = useState(null);
    useEffect(() => {
        const fetchJsonData = async () => {
            var test_only_the_type = false;
            var the_type = "table"
            if (test_only_the_type) {
                const result = await axios(
                    "/mein-studienstart-in-deutschland/@get_all_exercises/?type=" + the_type, {
                        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}
                    }
                );
                setExerciseList(result.data?.json?.exercises,);
            } else {
                const result = await axios(
                    searchParams.get("url") + '/@my_service_class', {
                        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}
                    }
                );
                setJsonData(result.data,);
                if (result.data?.my_service?.json?.type === 'part') {
                    setLesetext(result.data?.my_service?.enclosing_exam?.lesetext?.text,);
                    setExerciseList(result.data?.my_service?.json?.exercises,);
                } else {
                    setLesetext(result.data?.my_service?.enclosing_exam?.lesetext?.text,);
                    setExerciseList(result.data?.my_service?.json?.exercises,);
                    // setExerciseList([result.data?.my_service?.json],);
                }
            }
        };
        fetchJsonData();
        // console.log("searchParams");
    }, [searchParams]);
    useEffect(() => {
        // console.log(jsonData);
        // console.log("jsonData");
    }, [jsonData]);
    useEffect(() => {
        // console.log(jsonData);
        // console.log("exerciseList");
    }, [exerciseList]);
    useEffect(() => {
        // searchParams.forEach((key, val) => {
        //     console.log(key, val);
        // })
        // console.log("init");
    }, []);

    return (
        exerciseList && <MultipleExerciseComponent exerciseList={exerciseList} lesetext={lesetext}/>
    );
}
